import FixedAssetAPI from './_fixedAssetApi.js';
import httpClient from '@/apis/base/httpclient';

class FAAdjustmentAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FaAdjustments';
  /**
   * Lấy dữ liệu chứng từ đánh giá lại theo id tài sản
   * @param Object payload
   * @returns {*}
   * TVDAT 09/12/2022
   */
  async getVoucherByAsset(payload) {
    let request = {
      url: this.getAPIUrl() + '/getVoucherByAsset',
      data: { ...payload },
    };

    return httpClient.postAsync(request);
  }

  /**
   * Kiểm tra xem có chứng từ hao mòn chưa.
   * @param {} payload 
   * @returns 
   */
  async checkExistFaDepreciation(payload) {
    let request = {
      url: this.getAPIUrl() + '/checkExistFaDepreciation',
      data: payload ,
    };

    return httpClient.postAsync(request);
  }

}

export default new FAAdjustmentAPI();
